module.exports = __webpack_public_path__ + "static/media/leaderboard.3dd77d95.svg";